// import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import Swal from 'sweetalert2'
import api from '../service/service.js'
import DatePicker from 'vue2-datepicker'
export default {
  props: ['family_id', 'member_id', 'prefix_id', 'gender_id', 'fname', 'lname', 'id_card', 'age', 'nationality', 'race', 'brithday', 'occupation'],
  data () {
    return {
      time1: '',
      time2: '',
      time3: '',
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      shortcuts: [
        {
          text: 'Today',
          onClick: () => {
            this.time3 = [ new Date(), new Date() ]
          }
        }
      ],
      timePickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '23:30'
      },
      // member_id: '',
      // family_id: '',
      step_process: '',
      prefix: [],
      gender: []
      // prefix_id: 0,
      // gender_id: 1,
      // fname: '',
      // lname: '',
      // id_card: '',
      // age: '',
      // nationality: '',
      // race: '',
      // brithday: '',
      // occupation: ''
    }
  },
  components: {
    DatePicker
  },
  methods: {
    setDone () {
      Swal.fire({
        title: 'ยืนยันการอนุมัติ?',
        text: 'บันทึกข้อมูล!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then(result => {
        if (result.value) {
          if (this.member_id === 0) {
            console.log('member_id', this.member_id)
            this.addMember()
          } else {
            console.log('member_id', this.member_id)
            this.editMember()
          }
        }
      })
    },
    addMember () {
      let payload = {
        family_id: this.family_id,
        prefix_id: this.prefix_id,
        fname: this.fname,
        lname: this.lname,
        id_card: this.id_card,
        age: this.age,
        gender_id: this.gender_id,
        nationality: this.nationality,
        race: this.race,
        brithday: this.brithday,
        occupation: this.occupation
      }
      console.log(payload)
      api.memberAdd(
        payload,
        result => {
          console.log(result)
          if (result.result === true) {
            $('#Modal').modal('hide')
            this.alert_msg(
              'success',
              'ข้อความจากระบบ',
              'บันทึกสำเร็จ '
            )
          }
        },
        error => {
          alert(error)
          console.log(error)
        })
    },
    editMember () {
      let payload = {
        member_id: this.member_id,
        family_id: this.family_id,
        prefix_id: this.prefix_id,
        fname: this.fname,
        lname: this.lname,
        id_card: this.id_card,
        age: this.age,
        gender_id: this.gender_id,
        nationality: this.nationality,
        race: this.race,
        brithday: this.brithday,
        occupation: this.occupation
      }
      api.memberEdit(
        payload,
        result => {
          console.log(result)
          if (result.result === true) {
            $('#Modal').modal('hide')
            this.alert_msg(
              'success',
              'ข้อความจากระบบ',
              'บันทึกสำเร็จ '
            )
            this.$emit('eventVal')
          }
        },
        error => {
          alert(error)
          console.log(error)
        })
    },
    familyById () {
      if (this.member_id === 0) {
        return
      }
      let payload = this.member_id
      console.log('familyById:', payload)
      api.memberShowById(
        payload,
        result => {
          console.log(result)
          if (result.result === true) {
            this.member_id = result.data[0].member_id
            this.family_id = result.data[0].family_id
            this.prefix_id = result.data[0].prefix_id
            this.fname = result.data[0].fname
            this.lname = result.data[0].lname
            this.id_card = result.data[0].id_card
            this.age = result.data[0].age
            this.gender_id = result.data[0].gender_id
            this.nationality = result.data[0].nationality
            this.race = result.data[0].race
            this.brithday = result.data[0].brithday
            this.occupation = result.data[0].occupation
          }
        },
        error => {
          alert(error)
          console.log(error)
        })
    },
    getgender () {
      api.gender(
        result => {
          console.log(result)
          if (result.result === true) {
            this.gender = result.data
          }
        },
        calback => {
          console.log(calback)
        })
    },
    getprefix () {
      api.prefix(
        result => {
          console.log(result)
          if (result.result === true) {
            this.prefix = result.data
            console.log(this.prefix)
          }
        },
        calback => {
          console.log(calback)
        })
    },
    goindex () {
      $('#Modal').modal('hide')
    },
    test () {
      console.log('Modal:member_id =' + this.member_id)
      console.log('Modal:family_id =' + this.family_id)
    }
  },
  mounted () {
    this.getgender()
    this.getprefix()
    console.log('Modal:member_id =' + this.member_id)
    // this.step_process = setInterval(() => {
    //   console.log('setInterval')
    //   if (this.member_id) {
    //     this.familyById()
    //     clearInterval(this.step_process)
    //   }
    // }, 1000)
  }
}



// WEBPACK FOOTER //
// ./src/js/member_family.js